import { request } from '@app/rest/rest.lib'
import type { IApiConfig } from '@app/state/config/interfaces'

import type {
  CredentialsTokenResponse,
  ForgotPasswordResponse,
  OAuthTokenResponse,
  PasswordResetResponse,
} from './interfaces'

export function fetchOAuthToken(apiConfig: IApiConfig, oauthCode: string) {
  return request<OAuthTokenResponse>({
    method: 'post',
    url: `/api/v1/authenticate/${apiConfig.auth.oAuthProvider}`,
    data: {
      code: oauthCode,
      clientId: apiConfig.auth.oAuthClientId,
      redirectUrl: apiConfig.auth.oAuthRedirectUrl,
    },
  })
}

export function fetchCredentialsToken(email: string, password: string) {
  return request<CredentialsTokenResponse>({
    method: 'post',
    url: '/api/v1/authenticate/credentials',
    data: {
      identifier: email,
      password: password,
    },
  })
}

export function sendForgottenPasswordEmail(email: string) {
  return request<ForgotPasswordResponse>({
    method: 'post',
    url: '/api/v1/account/forgotPassword',
    data: {
      identifier: email,
    },
  })
}

export function requestPasswordReset(requestId: string, password: string) {
  return request<PasswordResetResponse>({
    method: 'post',
    url: '/api/v1/account/resetPassword',
    data: {
      changePasswordRequestId: requestId,
      password: password,
    },
  })
}
